import Vuex from 'vuex'
const store = new Vuex.Store({
  state: {
    interestData: null
  },
  mutations: {
    SET_INTEREST_DATA (state, data) {
      if (!data) {
        return
      }
      state.interestData = {
        ...(state.interestData || {}),
        ...data
      }
    }
  },
  actions: {}
})

export default store
